import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import GsapA1 from './gsapA1';

import { TweenMax, TimelineMax } from 'gsap';

export default function AnimationA({}: any) {
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const { useEffect } = useGlobal();

    useEffect(() => {
        const controller = new ScrollMagic.Controller();
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.homeVideo',
            offset: -64, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '64px', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            '.homeVideo .watch-field .first',
            0.3,
            {
                opacity: 1,
                y: 0,
                ease: 'linear',
            },
            {
                opacity: 0,
                y: -40,
                ease: 'linear',
            },
        );

        const tweenA2 = TweenMax.fromTo(
            '.homeVideo .watch-field .second',
            0.3,
            {
                opacity: 0,
                ease: 'linear',
            },
            {
                opacity: 1,
                ease: 'linear',
            },
        );

        const timelineA1 = new TimelineMax();
        timelineA1.add(tweenA1).add(tweenA2, 0.3);
        sceneA1.setTween(timelineA1);

        controller.addScene(sceneA1);
    }, []);

    return (
        <>
            <div className={`${css.homeVideo} homeVideo`}>
                <div className="ef-scroll-ani-total-box">
                    <div className="ef-scroll-ani ef-scroll-ani-a0">
                        <div className="ef-scroll-ani-trigger">
                            <GsapA1 />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
